import { all } from 'redux-saga/effects';

import fetchWorkorders from './fetchWorkorders';

export default function* () {
    yield all([fetchWorkorders()]);
}
